<script setup>
import { Head, usePage } from '@inertiajs/vue3'
import { computed, watch } from 'vue';

const page = usePage();

const title = computed(() => page.props.meta?.title || 'c-o-d-e-s software development | Maatwerk Software & Platform Oplossingen');
const description = computed(() => page.props.meta?.description || 'Indexa is a platform for managing your projects and tasks.');

import Header from './Header.vue';
import Footer from './Footer.vue';
</script>

<template>
    <Head :title="title" :description="description" />

    <Header />

    <slot />
    
    <Footer />
</template>